
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import RoundSelect from '@/components/molecules/RoundSelect.vue'
import CurriculumUnitList from '@/components/organisms/manage/proofread/CurriculumUnitList.vue'
import { SelectItem } from '@/models/SelectItem'
import { ProofreadUnit } from '@/models/manage/ProofreadList'

/**
 * 校正画面-単元一覧
 */
@Component({
  components: {
    ManageSidemenuLayout,
    PanelFrame,
    RoundSelect,
    CurriculumUnitList,
  },
})
export default class ProofreadCurriculumUnits extends Vue {
  /** 学年フィルター */
  @Ref()
  gradeFilter!: RoundSelect

  /** 教科フィルター */
  @Ref()
  subjectFilter!: RoundSelect

  /** 塾管理権限の画面か否か */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** システム管理権限の画面か否か(未使用) */
  @Prop({ default: false })
  private isAdmin!: boolean

  /** 学年一覧 */
  @Prop()
  private gradeList!: SelectItem[]

  /** 学年の初期選択値 */
  @Prop()
  private defaultGradeCode!: string

  /** 教科一覧 */
  @Prop()
  private subjectList!: SelectItem[]

  /** 教科の初期選択値 */
  @Prop()
  private defaultSubjectCode!: string

  /** 単元一覧 */
  @Prop()
  private unitList!: ProofreadUnit[]

  /** 単元選択時の処理 */
  @Prop()
  private eventSelectUnit!: (id: number) => Promise<void>

  /** 条件変更時の処理 */
  @Prop()
  private eventChangeFilter!: () => Promise<void>

  /**
   * 選択中の学年コード
   *
   * @returns 学年コード
   */
  public get gradeCode(): string | null {
    if (!this.gradeFilter) {
      return null
    }
    return this.gradeFilter.selectedValue()
  }

  /**
   * 選択中の教科コード
   *
   * @returns 教科コード
   */
  public get subjectCode(): string | null {
    if (!this.subjectFilter) {
      return null
    }
    return this.subjectFilter.selectedValue()
  }
}
